<div class="qc">

  <header class="qc__header">
    <div>
      <h1 class="qc__title">{{ 'QUESTION_CREATE.TITLE' | translate }}</h1>
      <p class="qc__subtitle">{{ 'QUESTION_CREATE.SUBTITLE' | translate }}</p>
    </div>

    @if (createdCount() > 0) {
      <span class="qc__counter">
        {{ 'QUESTION_CREATE.CREATED_COUNT' | translate: { count: createdCount() } }}
      </span>
    }
  </header>

  <!-- ═══ Étape 1 : la portée ═══ -->
  @if (step() === 'scope') {
    <section class="qc__card">
      <div class="qc__card-head">
        <h2>{{ 'QUESTION_CREATE.SCOPE_TITLE' | translate }}</h2>
        <p>{{ 'QUESTION_CREATE.SCOPE_HELP' | translate }}</p>
      </div>

      @if (scopeErrored()) {
        <app-error-state
          titleKey="QUESTION_CREATE.SCOPE_ERROR_TITLE"
          messageKey="QUESTION_CREATE.SCOPE_ERROR_DESC"
          (retry)="loadPaths()"></app-error-state>
      } @else {
        <div class="qc__card-body">
          <div class="qc__fields">

            <div class="qc__field">
              <label for="qc-path">{{ 'QUESTION_CREATE.LEVEL' | translate }}</label>
              <select id="qc-path"
                      [disabled]="loadingScope()"
                      (change)="onPath($any($event.target).value)">
                <option value="">{{ 'QUESTION_CREATE.PICK_LEVEL' | translate }}</option>
                @for (p of paths(); track p.id) {
                  <option [value]="p.id" [selected]="p.id === pathId()">{{ p.title }}</option>
                }
              </select>
            </div>

            <div class="qc__field">
              <label for="qc-subject">{{ 'QUESTION_CREATE.SUBJECT' | translate }}</label>
              <select id="qc-subject"
                      [disabled]="!pathId() || subjects().length === 0"
                      (change)="onSubject($any($event.target).value)">
                <option value="">{{ 'QUESTION_CREATE.PICK_SUBJECT' | translate }}</option>
                @for (s of subjects(); track s.id) {
                  <option [value]="s.id" [selected]="s.id === subjectId()">{{ s.name }}</option>
                }
              </select>
            </div>

            <div class="qc__field">
              <label for="qc-theme">{{ 'QUESTION_CREATE.CHAPTER' | translate }}</label>
              <select id="qc-theme"
                      [disabled]="!subjectId() || themes().length === 0"
                      (change)="onTheme($any($event.target).value)">
                <option value="">{{ 'QUESTION_CREATE.PICK_CHAPTER' | translate }}</option>
                @for (t of themes(); track t.id) {
                  <option [value]="t.id" [selected]="t.id === themeId()">{{ t.title }}</option>
                }
              </select>
            </div>

          </div>

          @if (pathId() && subjects().length === 0 && !loadingScope()) {
            <p class="qc__note">{{ 'QUESTION_CREATE.NO_SUBJECT' | translate }}</p>
          }
          @if (subjectId() && themes().length === 0) {
            <p class="qc__note">{{ 'QUESTION_CREATE.NO_CHAPTER' | translate }}</p>
          }

          <div class="qc__actions">
            <button type="button" class="btn btn-outline-secondary" (click)="cancel()">
              {{ 'BUTTONS.CANCEL' | translate }}
            </button>
            <button type="button" class="btn btn-primary"
                    [disabled]="!canStart()"
                    (click)="start()">
              {{ 'QUESTION_CREATE.START' | translate }}
            </button>
          </div>
        </div>
      }
    </section>
  }

  <!-- ═══ Étape 2 : la saisie ═══ -->
  @if (step() === 'editor') {
    <div class="qc__scope-bar">
      <span class="qc__scope-label">{{ scopeLabel() }}</span>
      <button type="button" class="btn btn-sm btn-outline-secondary" (click)="againOtherChapter()">
        {{ 'QUESTION_CREATE.CHANGE_SCOPE' | translate }}
      </button>
    </div>

    <app-question-editor
      [initialValue]="null"
      (save)="onSave($event)"
      (cancel)="cancel()">
    </app-question-editor>
  }

  <!-- ═══ Étape 3 : et ensuite ? ═══ -->
  @if (step() === 'saved') {
    <section class="qc__card qc__card--done">
      <div class="qc__done">
        <span class="qc__done-ico" aria-hidden="true">✓</span>
        <h2>{{ 'QUESTION_CREATE.SAVED_TITLE' | translate }}</h2>
        <p class="qc__done-title">{{ lastTitle() }}</p>
        <p class="qc__done-scope">{{ scopeLabel() }}</p>

        <p class="qc__done-ask">{{ 'QUESTION_CREATE.ASK_ANOTHER' | translate }}</p>

        <div class="qc__done-actions">
          <button type="button" class="btn btn-primary" (click)="againSameChapter()">
            {{ 'QUESTION_CREATE.AGAIN_SAME' | translate }}
          </button>
          <button type="button" class="btn btn-outline-primary" (click)="againOtherChapter()">
            {{ 'QUESTION_CREATE.AGAIN_OTHER' | translate }}
          </button>
          <button type="button" class="btn btn-outline-secondary" (click)="finish()">
            {{ 'QUESTION_CREATE.FINISH' | translate }}
          </button>
        </div>

        <p class="qc__done-note">{{ 'QUESTION_CREATE.DRAFT_NOTE' | translate }}</p>
      </div>
    </section>
  }

</div>
